





















import { Component, Prop, Vue } from 'vue-property-decorator';

import { KinesisEndpoint } from '@/types/core-push';

@Component
export default class KinesisEndpointView extends Vue {
  
  @Prop({ default: {},  type: Object}) kinesisEndpoint!: KinesisEndpoint;

  
}
